import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { FlexBox, Stack } from '@ardoq/layout';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';

type NoReferencesOrListFieldsDoqProps = {
  doqType: DoqType;
  i18nLocale: I18nLocale;
};

const NoReferencesOrListFieldsDoqBase = ({
  doqType,
  i18nLocale,
}: NoReferencesOrListFieldsDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noReferencesOrListFields.title',
          'There is nothing to show'
        )}
        message={
          <Stack gap="xlarge">
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noReferencesOrListFields.message1',
                "This workspace doesn't have any references or list fields."
              )}
            </FlexBox>
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noReferencesOrListFields.message2',
                'To use this view, add a list field to the workspace or have at least one component referencing another.'
              )}
            </FlexBox>
          </Stack>
        }
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoReferencesOrListFieldsDoq = connect(
  NoReferencesOrListFieldsDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
